import CodebookValueNotFoundError from '../CodebookValueNotFoundError'
import { TranslatableNameCodebook } from '../TranslatableNameCodebook'
import { $t } from '../../composables/i18n'
import { CountryISO3 } from './CountryISO3'
import { CountryISO2 } from './CountryISO2'
import { CountryId } from './CountryId'

export class Country extends TranslatableNameCodebook {
  private constructor(
    public readonly id: CountryId,
    public readonly iso3: CountryISO3,
    public readonly iso2: CountryISO2,
    name: string,
  ) {
    super(name)
  }

  static readonly CZE = new Country(
    CountryId.CZE,
    CountryISO3.CZE,
    CountryISO2.CZ,
    $t('Czech Republic'),
  )
  static readonly AFG = new Country(
    CountryId.AFG,
    CountryISO3.AFG,
    CountryISO2.AF,
    $t('Afghanistan'),
  )
  static readonly ALB = new Country(CountryId.ALB, CountryISO3.ALB, CountryISO2.AL, $t('Albania'))
  static readonly DZA = new Country(CountryId.DZA, CountryISO3.DZA, CountryISO2.DZ, $t('Algeria'))
  static readonly ASM = new Country(
    CountryId.ASM,
    CountryISO3.ASM,
    CountryISO2.AS,
    $t('American Samoa'),
  )
  static readonly VIR = new Country(
    CountryId.VIR,
    CountryISO3.VIR,
    CountryISO2.VI,
    $t('American Virgin Islands'),
  )
  static readonly AND = new Country(CountryId.AND, CountryISO3.AND, CountryISO2.AD, $t('Andorra'))
  static readonly AGO = new Country(CountryId.AGO, CountryISO3.AGO, CountryISO2.AO, $t('Angola'))
  static readonly AIA = new Country(CountryId.AIA, CountryISO3.AIA, CountryISO2.AI, $t('Anguilla'))
  static readonly ATA = new Country(
    CountryId.ATA,
    CountryISO3.ATA,
    CountryISO2.AQ,
    $t('Antarctica'),
  )
  static readonly ATG = new Country(
    CountryId.ATG,
    CountryISO3.ATG,
    CountryISO2.AG,
    $t('Antigua and Barbuda'),
  )
  static readonly ARG = new Country(CountryId.ARG, CountryISO3.ARG, CountryISO2.AR, $t('Argentina'))
  static readonly ARM = new Country(CountryId.ARM, CountryISO3.ARM, CountryISO2.AM, $t('Armenia'))
  static readonly ABW = new Country(CountryId.ABW, CountryISO3.ABW, CountryISO2.AW, $t('Aruba'))
  static readonly AUS = new Country(CountryId.AUS, CountryISO3.AUS, CountryISO2.AU, $t('Australia'))
  static readonly BHS = new Country(CountryId.BHS, CountryISO3.BHS, CountryISO2.BS, $t('Bahamas'))
  static readonly BHR = new Country(CountryId.BHR, CountryISO3.BHR, CountryISO2.BH, $t('Bahrain'))
  static readonly BGD = new Country(
    CountryId.BGD,
    CountryISO3.BGD,
    CountryISO2.BD,
    $t('Bangladesh'),
  )
  static readonly BRB = new Country(CountryId.BRB, CountryISO3.BRB, CountryISO2.BB, $t('Barbados'))
  static readonly BEL = new Country(CountryId.BEL, CountryISO3.BEL, CountryISO2.BE, $t('Belgium'))
  static readonly BLZ = new Country(CountryId.BLZ, CountryISO3.BLZ, CountryISO2.BZ, $t('Belize'))
  static readonly BLR = new Country(CountryId.BLR, CountryISO3.BLR, CountryISO2.BY, $t('Belarus'))
  static readonly BEN = new Country(CountryId.BEN, CountryISO3.BEN, CountryISO2.BJ, $t('Benin'))
  static readonly BMU = new Country(CountryId.BMU, CountryISO3.BMU, CountryISO2.BM, $t('Bermuda'))
  static readonly BTN = new Country(CountryId.BTN, CountryISO3.BTN, CountryISO2.BT, $t('Bhutan'))
  static readonly BOL = new Country(CountryId.BOL, CountryISO3.BOL, CountryISO2.BO, $t('Bolivia'))
  static readonly BIH = new Country(
    CountryId.BIH,
    CountryISO3.BIH,
    CountryISO2.BA,
    $t('Bosnia and Herzegovina'),
  )
  static readonly BWA = new Country(CountryId.BWA, CountryISO3.BWA, CountryISO2.BW, $t('Botswana'))
  static readonly BVT = new Country(
    CountryId.BVT,
    CountryISO3.BVT,
    CountryISO2.BV,
    $t('Bouvet Island'),
  )
  static readonly BRA = new Country(CountryId.BRA, CountryISO3.BRA, CountryISO2.BR, $t('Brazil'))
  static readonly IOT = new Country(
    CountryId.IOT,
    CountryISO3.IOT,
    CountryISO2.IO,
    $t('British Indian Ocean Territory'),
  )
  static readonly VGB = new Country(
    CountryId.VGB,
    CountryISO3.VGB,
    CountryISO2.VG,
    $t('British Virgin Islands'),
  )
  static readonly BRN = new Country(CountryId.BRN, CountryISO3.BRN, CountryISO2.BN, $t('Brunei'))
  static readonly BGR = new Country(CountryId.BGR, CountryISO3.BGR, CountryISO2.BG, $t('Bulgaria'))
  static readonly BFA = new Country(
    CountryId.BFA,
    CountryISO3.BFA,
    CountryISO2.BF,
    $t('Burkina Faso'),
  )
  static readonly BDI = new Country(CountryId.BDI, CountryISO3.BDI, CountryISO2.BI, $t('Burundi'))
  static readonly COK = new Country(
    CountryId.COK,
    CountryISO3.COK,
    CountryISO2.CK,
    $t('Cook Islands'),
  )
  static readonly CHN = new Country(CountryId.CHN, CountryISO3.CHN, CountryISO2.CN, $t('China'))
  static readonly DNK = new Country(CountryId.DNK, CountryISO3.DNK, CountryISO2.DK, $t('Denmark'))
  static readonly DMA = new Country(CountryId.DMA, CountryISO3.DMA, CountryISO2.DM, $t('Dominica'))
  static readonly DOM = new Country(
    CountryId.DOM,
    CountryISO3.DOM,
    CountryISO2.DO,
    $t('Dominican Republic'),
  )
  static readonly DJI = new Country(CountryId.DJI, CountryISO3.DJI, CountryISO2.DJ, $t('Djibouti'))
  static readonly TCD = new Country(CountryId.TCD, CountryISO3.TCD, CountryISO2.TD, $t('Chad'))
  static readonly EGY = new Country(CountryId.EGY, CountryISO3.EGY, CountryISO2.EG, $t('Egypt'))
  static readonly ECU = new Country(CountryId.ECU, CountryISO3.ECU, CountryISO2.EC, $t('Ecuador'))
  static readonly ERI = new Country(CountryId.ERI, CountryISO3.ERI, CountryISO2.ER, $t('Eritrea'))
  static readonly EST = new Country(CountryId.EST, CountryISO3.EST, CountryISO2.EE, $t('Estonia'))
  static readonly ETH = new Country(CountryId.ETH, CountryISO3.ETH, CountryISO2.ET, $t('Ethiopia'))
  static readonly FRO = new Country(
    CountryId.FRO,
    CountryISO3.FRO,
    CountryISO2.FO,
    $t('Faroe Islands'),
  )
  static readonly FLK = new Country(
    CountryId.FLK,
    CountryISO3.FLK,
    CountryISO2.FK,
    $t('Falkland Islands'),
  )
  static readonly FJI = new Country(CountryId.FJI, CountryISO3.FJI, CountryISO2.FJ, $t('Fiji'))
  static readonly PHL = new Country(
    CountryId.PHL,
    CountryISO3.PHL,
    CountryISO2.PH,
    $t('Philippines'),
  )
  static readonly FIN = new Country(CountryId.FIN, CountryISO3.FIN, CountryISO2.FI, $t('Finland'))
  static readonly FRA = new Country(CountryId.FRA, CountryISO3.FRA, CountryISO2.FR, $t('France'))
  static readonly GAB = new Country(CountryId.GAB, CountryISO3.GAB, CountryISO2.GA, $t('Gabon'))
  static readonly GMB = new Country(CountryId.GMB, CountryISO3.GMB, CountryISO2.GM, $t('Gambia'))
  static readonly GHA = new Country(CountryId.GHA, CountryISO3.GHA, CountryISO2.GH, $t('Ghana'))
  static readonly GIB = new Country(CountryId.GIB, CountryISO3.GIB, CountryISO2.GI, $t('Gibraltar'))
  static readonly GRD = new Country(CountryId.GRD, CountryISO3.GRD, CountryISO2.GD, $t('Grenada'))
  static readonly GRL = new Country(CountryId.GRL, CountryISO3.GRL, CountryISO2.GL, $t('Greenland'))
  static readonly GEO = new Country(CountryId.GEO, CountryISO3.GEO, CountryISO2.GE, $t('Georgia'))
  static readonly GUM = new Country(CountryId.GUM, CountryISO3.GUM, CountryISO2.GU, $t('Guam'))
  static readonly GTM = new Country(CountryId.GTM, CountryISO3.GTM, CountryISO2.GT, $t('Guatemala'))
  static readonly GIN = new Country(CountryId.GIN, CountryISO3.GIN, CountryISO2.GN, $t('Guinea'))
  static readonly GNB = new Country(
    CountryId.GNB,
    CountryISO3.GNB,
    CountryISO2.GW,
    $t('Guinea - Bissau'),
  )
  static readonly GUY = new Country(CountryId.GUY, CountryISO3.GUY, CountryISO2.GY, $t('Guyana'))
  static readonly HTI = new Country(CountryId.HTI, CountryISO3.HTI, CountryISO2.HT, $t('Haiti'))
  static readonly HMD = new Country(
    CountryId.HMD,
    CountryISO3.HMD,
    CountryISO2.HM,
    $t('Heard Island and McDonald Islands'),
  )
  static readonly HND = new Country(CountryId.HND, CountryISO3.HND, CountryISO2.HN, $t('Honduras'))
  static readonly HKG = new Country(CountryId.HKG, CountryISO3.HKG, CountryISO2.HK, $t('Hong Kong'))
  static readonly CHL = new Country(CountryId.CHL, CountryISO3.CHL, CountryISO2.CL, $t('Chile'))
  static readonly HRV = new Country(CountryId.HRV, CountryISO3.HRV, CountryISO2.HR, $t('Croatia'))
  static readonly IND = new Country(CountryId.IND, CountryISO3.IND, CountryISO2.IN, $t('India'))
  static readonly IDN = new Country(CountryId.IDN, CountryISO3.IDN, CountryISO2.ID, $t('Indonesia'))
  static readonly IRQ = new Country(CountryId.IRQ, CountryISO3.IRQ, CountryISO2.IQ, $t('Iraq'))
  static readonly IRN = new Country(CountryId.IRN, CountryISO3.IRN, CountryISO2.IR, $t('Iran'))
  static readonly IRL = new Country(CountryId.IRL, CountryISO3.IRL, CountryISO2.IE, $t('Ireland'))
  static readonly ISL = new Country(CountryId.ISL, CountryISO3.ISL, CountryISO2.IS, $t('Iceland'))
  static readonly ITA = new Country(CountryId.ITA, CountryISO3.ITA, CountryISO2.IT, $t('Italy'))
  static readonly ISR = new Country(CountryId.ISR, CountryISO3.ISR, CountryISO2.IL, $t('Israel'))
  static readonly JAM = new Country(CountryId.JAM, CountryISO3.JAM, CountryISO2.JM, $t('Jamaica'))
  static readonly JPN = new Country(CountryId.JPN, CountryISO3.JPN, CountryISO2.JP, $t('Japan'))
  static readonly YEM = new Country(CountryId.YEM, CountryISO3.YEM, CountryISO2.YE, $t('Yemen'))
  static readonly ZAF = new Country(
    CountryId.ZAF,
    CountryISO3.ZAF,
    CountryISO2.ZA,
    $t('South Africa'),
  )
  static readonly SGS = new Country(
    CountryId.SGS,
    CountryISO3.SGS,
    CountryISO2.GS,
    $t('South Georgia and the South Sandwich Islands'),
  )
  static readonly JOR = new Country(CountryId.JOR, CountryISO3.JOR, CountryISO2.JO, $t('Jordan'))
  static readonly CYM = new Country(
    CountryId.CYM,
    CountryISO3.CYM,
    CountryISO2.KY,
    $t('Cayman Islands'),
  )
  static readonly KHM = new Country(CountryId.KHM, CountryISO3.KHM, CountryISO2.KH, $t('Cambodia'))
  static readonly CMR = new Country(CountryId.CMR, CountryISO3.CMR, CountryISO2.CM, $t('Cameroon'))
  static readonly CAN = new Country(CountryId.CAN, CountryISO3.CAN, CountryISO2.CA, $t('Canada'))
  static readonly CPV = new Country(
    CountryId.CPV,
    CountryISO3.CPV,
    CountryISO2.CV,
    $t('Cape Verde'),
  )
  static readonly QAT = new Country(CountryId.QAT, CountryISO3.QAT, CountryISO2.QA, $t('Qatar'))
  static readonly KAZ = new Country(
    CountryId.KAZ,
    CountryISO3.KAZ,
    CountryISO2.KZ,
    $t('Kazakhstan'),
  )
  static readonly KEN = new Country(CountryId.KEN, CountryISO3.KEN, CountryISO2.KE, $t('Kenya'))
  static readonly KIR = new Country(CountryId.KIR, CountryISO3.KIR, CountryISO2.KI, $t('Kiribati'))
  static readonly CCK = new Country(
    CountryId.CCK,
    CountryISO3.CCK,
    CountryISO2.CC,
    $t('Cocos Islands'),
  )
  static readonly COL = new Country(CountryId.COL, CountryISO3.COL, CountryISO2.CO, $t('Colombia'))
  static readonly COM = new Country(CountryId.COM, CountryISO3.COM, CountryISO2.KM, $t('Comoros'))
  static readonly COG = new Country(CountryId.COG, CountryISO3.COG, CountryISO2.CG, $t('Congo'))
  static readonly COD = new Country(
    CountryId.COD,
    CountryISO3.COD,
    CountryISO2.CD,
    $t('Democratic Republic of the Congo'),
  )
  static readonly PRK = new Country(
    CountryId.PRK,
    CountryISO3.PRK,
    CountryISO2.KP,
    $t('North Korea'),
  )
  static readonly KOR = new Country(
    CountryId.KOR,
    CountryISO3.KOR,
    CountryISO2.KR,
    $t('South Korea'),
  )
  static readonly CRI = new Country(
    CountryId.CRI,
    CountryISO3.CRI,
    CountryISO2.CR,
    $t('Costa Rica'),
  )
  static readonly CUB = new Country(CountryId.CUB, CountryISO3.CUB, CountryISO2.CU, $t('Cuba'))
  static readonly KWT = new Country(CountryId.KWT, CountryISO3.KWT, CountryISO2.KW, $t('Kuwait'))
  static readonly CYP = new Country(CountryId.CYP, CountryISO3.CYP, CountryISO2.CY, $t('Cyprus'))
  static readonly KGZ = new Country(
    CountryId.KGZ,
    CountryISO3.KGZ,
    CountryISO2.KG,
    $t('Kyrgyzstan'),
  )
  static readonly LAO = new Country(CountryId.LAO, CountryISO3.LAO, CountryISO2.LA, $t('Laos'))
  static readonly LSO = new Country(CountryId.LSO, CountryISO3.LSO, CountryISO2.LS, $t('Lesotho'))
  static readonly LBN = new Country(CountryId.LBN, CountryISO3.LBN, CountryISO2.LB, $t('Libanon'))
  static readonly LBR = new Country(CountryId.LBR, CountryISO3.LBR, CountryISO2.LR, $t('Liberia'))
  static readonly LBY = new Country(CountryId.LBY, CountryISO3.LBY, CountryISO2.LY, $t('Libya'))
  static readonly LIE = new Country(
    CountryId.LIE,
    CountryISO3.LIE,
    CountryISO2.LI,
    $t('Liechtenstein'),
  )
  static readonly LTU = new Country(CountryId.LTU, CountryISO3.LTU, CountryISO2.LT, $t('Lithuania'))
  static readonly LVA = new Country(CountryId.LVA, CountryISO3.LVA, CountryISO2.LV, $t('Latvia'))
  static readonly LUX = new Country(
    CountryId.LUX,
    CountryISO3.LUX,
    CountryISO2.LU,
    $t('Luxembourg'),
  )
  static readonly MAC = new Country(CountryId.MAC, CountryISO3.MAC, CountryISO2.MO, $t('Macao'))
  static readonly MDG = new Country(
    CountryId.MDG,
    CountryISO3.MDG,
    CountryISO2.MG,
    $t('Madagascar'),
  )
  static readonly HUN = new Country(CountryId.HUN, CountryISO3.HUN, CountryISO2.HU, $t('Hungary'))
  static readonly MKD = new Country(CountryId.MKD, CountryISO3.MKD, CountryISO2.MK, $t('Macedonia'))
  static readonly MYS = new Country(CountryId.MYS, CountryISO3.MYS, CountryISO2.MY, $t('Malaysia'))
  static readonly MWI = new Country(CountryId.MWI, CountryISO3.MWI, CountryISO2.MW, $t('Malawi'))
  static readonly MDV = new Country(CountryId.MDV, CountryISO3.MDV, CountryISO2.MV, $t('Maldives'))
  static readonly MLI = new Country(CountryId.MLI, CountryISO3.MLI, CountryISO2.ML, $t('Mali'))
  static readonly MLT = new Country(CountryId.MLT, CountryISO3.MLT, CountryISO2.MT, $t('Malta'))
  static readonly MAR = new Country(CountryId.MAR, CountryISO3.MAR, CountryISO2.MA, $t('Morocco'))
  static readonly MHL = new Country(
    CountryId.MHL,
    CountryISO3.MHL,
    CountryISO2.MH,
    $t('Marshall Islands'),
  )
  static readonly MUS = new Country(CountryId.MUS, CountryISO3.MUS, CountryISO2.MU, $t('Mauritius'))
  static readonly MRT = new Country(
    CountryId.MRT,
    CountryISO3.MRT,
    CountryISO2.MR,
    $t('Mauritania'),
  )
  static readonly UMI = new Country(
    CountryId.UMI,
    CountryISO3.UMI,
    CountryISO2.UM,
    $t('United States Minor Outlying Islands'),
  )
  static readonly MEX = new Country(CountryId.MEX, CountryISO3.MEX, CountryISO2.MX, $t('Mexico'))
  static readonly FSM = new Country(
    CountryId.FSM,
    CountryISO3.FSM,
    CountryISO2.FM,
    $t('Micronesia'),
  )
  static readonly MDA = new Country(CountryId.MDA, CountryISO3.MDA, CountryISO2.MD, $t('Moldova'))
  static readonly MCO = new Country(CountryId.MCO, CountryISO3.MCO, CountryISO2.MC, $t('Monaco'))
  static readonly MNG = new Country(CountryId.MNG, CountryISO3.MNG, CountryISO2.MN, $t('Mongolia'))
  static readonly MSR = new Country(
    CountryId.MSR,
    CountryISO3.MSR,
    CountryISO2.MS,
    $t('Montserrat'),
  )
  static readonly MOZ = new Country(
    CountryId.MOZ,
    CountryISO3.MOZ,
    CountryISO2.MZ,
    $t('Mozambique'),
  )
  static readonly MMR = new Country(CountryId.MMR, CountryISO3.MMR, CountryISO2.MM, $t('Myanmar'))
  static readonly NAM = new Country(CountryId.NAM, CountryISO3.NAM, CountryISO2.NA, $t('Namibia'))
  static readonly NRU = new Country(CountryId.NRU, CountryISO3.NRU, CountryISO2.NR, $t('Nauru'))
  static readonly DEU = new Country(CountryId.DEU, CountryISO3.DEU, CountryISO2.DE, $t('Germany'))
  static readonly NPL = new Country(CountryId.NPL, CountryISO3.NPL, CountryISO2.NP, $t('Nepal'))
  static readonly NER = new Country(CountryId.NER, CountryISO3.NER, CountryISO2.NE, $t('Niger'))
  static readonly NGA = new Country(CountryId.NGA, CountryISO3.NGA, CountryISO2.NG, $t('Nigeria'))
  static readonly NIC = new Country(CountryId.NIC, CountryISO3.NIC, CountryISO2.NI, $t('Nicaragua'))
  static readonly NIU = new Country(CountryId.NIU, CountryISO3.NIU, CountryISO2.NU, $t('Niue'))
  static readonly NLD = new Country(
    CountryId.NLD,
    CountryISO3.NLD,
    CountryISO2.NL,
    $t('Netherlands'),
  )
  static readonly NFK = new Country(
    CountryId.NFK,
    CountryISO3.NFK,
    CountryISO2.NF,
    $t('Norfolk Island'),
  )
  static readonly NOR = new Country(CountryId.NOR, CountryISO3.NOR, CountryISO2.NO, $t('Norway'))
  static readonly NZL = new Country(
    CountryId.NZL,
    CountryISO3.NZL,
    CountryISO2.NZ,
    $t('New Zealand'),
  )
  static readonly OMN = new Country(CountryId.OMN, CountryISO3.OMN, CountryISO2.OM, $t('Oman'))
  static readonly PAK = new Country(CountryId.PAK, CountryISO3.PAK, CountryISO2.PK, $t('Pakistan'))
  static readonly PLW = new Country(CountryId.PLW, CountryISO3.PLW, CountryISO2.PW, $t('Palau'))
  static readonly PAN = new Country(CountryId.PAN, CountryISO3.PAN, CountryISO2.PA, $t('Panama'))
  static readonly PNG = new Country(
    CountryId.PNG,
    CountryISO3.PNG,
    CountryISO2.PG,
    $t('Papua New Guinea'),
  )
  static readonly PRY = new Country(CountryId.PRY, CountryISO3.PRY, CountryISO2.PY, $t('Paraguay'))
  static readonly PER = new Country(CountryId.PER, CountryISO3.PER, CountryISO2.PE, $t('Peru'))
  static readonly PCN = new Country(
    CountryId.PCN,
    CountryISO3.PCN,
    CountryISO2.PN,
    $t('Pitcairn Islands'),
  )
  static readonly CIV = new Country(
    CountryId.CIV,
    CountryISO3.CIV,
    CountryISO2.CI,
    $t('Ivory Coast'),
  )
  static readonly POL = new Country(CountryId.POL, CountryISO3.POL, CountryISO2.PL, $t('Poland'))
  static readonly PRI = new Country(
    CountryId.PRI,
    CountryISO3.PRI,
    CountryISO2.PR,
    $t('Puerto Rico'),
  )
  static readonly PRT = new Country(CountryId.PRT, CountryISO3.PRT, CountryISO2.PT, $t('Portugal'))
  static readonly AUT = new Country(CountryId.AUT, CountryISO3.AUT, CountryISO2.AT, $t('Austria'))
  static readonly GNQ = new Country(
    CountryId.GNQ,
    CountryISO3.GNQ,
    CountryISO2.GQ,
    $t('Equatorial Guinea'),
  )
  static readonly ROU = new Country(CountryId.ROU, CountryISO3.ROU, CountryISO2.RO, $t('Romania'))
  static readonly RUS = new Country(CountryId.RUS, CountryISO3.RUS, CountryISO2.RU, $t('Russia'))
  static readonly RWA = new Country(CountryId.RWA, CountryISO3.RWA, CountryISO2.RW, $t('Rwanda'))
  static readonly GRC = new Country(CountryId.GRC, CountryISO3.GRC, CountryISO2.GR, $t('Greece'))
  static readonly SLV = new Country(
    CountryId.SLV,
    CountryISO3.SLV,
    CountryISO2.SV,
    $t('El Salvador'),
  )
  static readonly WSM = new Country(CountryId.WSM, CountryISO3.WSM, CountryISO2.WS, $t('Samoa'))
  static readonly SMR = new Country(
    CountryId.SMR,
    CountryISO3.SMR,
    CountryISO2.SM,
    $t('San Marino'),
  )
  static readonly SAU = new Country(
    CountryId.SAU,
    CountryISO3.SAU,
    CountryISO2.SA,
    $t('Saudi Arabia'),
  )
  static readonly SEN = new Country(CountryId.SEN, CountryISO3.SEN, CountryISO2.SN, $t('Senegal'))
  static readonly MNP = new Country(
    CountryId.MNP,
    CountryISO3.MNP,
    CountryISO2.MP,
    $t('Northern Mariana Islands'),
  )
  static readonly SYC = new Country(
    CountryId.SYC,
    CountryISO3.SYC,
    CountryISO2.SC,
    $t('Seychelles'),
  )
  static readonly SLE = new Country(
    CountryId.SLE,
    CountryISO3.SLE,
    CountryISO2.SL,
    $t('Sierra Leone'),
  )
  static readonly SGP = new Country(CountryId.SGP, CountryISO3.SGP, CountryISO2.SG, $t('Singapore'))
  static readonly SVK = new Country(CountryId.SVK, CountryISO3.SVK, CountryISO2.SK, $t('Slovakia'))
  static readonly SVN = new Country(CountryId.SVN, CountryISO3.SVN, CountryISO2.SI, $t('Slovenia'))
  static readonly SOM = new Country(CountryId.SOM, CountryISO3.SOM, CountryISO2.SO, $t('Somalia'))
  static readonly ARE = new Country(
    CountryId.ARE,
    CountryISO3.ARE,
    CountryISO2.AE,
    $t('United Arab Emirates'),
  )
  static readonly USA = new Country(
    CountryId.USA,
    CountryISO3.USA,
    CountryISO2.US,
    $t('United States of America'),
  )
  static readonly LKA = new Country(CountryId.LKA, CountryISO3.LKA, CountryISO2.LK, $t('Sri Lanka'))
  static readonly CAF = new Country(
    CountryId.CAF,
    CountryISO3.CAF,
    CountryISO2.CF,
    $t('Central African Republic'),
  )
  static readonly SDN = new Country(CountryId.SDN, CountryISO3.SDN, CountryISO2.SD, $t('Sudan'))
  static readonly SUR = new Country(CountryId.SUR, CountryISO3.SUR, CountryISO2.SR, $t('Suriname'))
  static readonly SJM = new Country(
    CountryId.SJM,
    CountryISO3.SJM,
    CountryISO2.SJ,
    $t('Svalbard and Jan Mayen'),
  )
  static readonly SHN = new Country(
    CountryId.SHN,
    CountryISO3.SHN,
    CountryISO2.SH,
    $t('Saint Helena'),
  )
  static readonly LCA = new Country(
    CountryId.LCA,
    CountryISO3.LCA,
    CountryISO2.LC,
    $t('Saint Lucia'),
  )
  static readonly KNA = new Country(
    CountryId.KNA,
    CountryISO3.KNA,
    CountryISO2.KN,
    $t('Saint Kitts and Nevis'),
  )
  static readonly STP = new Country(
    CountryId.STP,
    CountryISO3.STP,
    CountryISO2.ST,
    $t('Sao Tome and Principe'),
  )
  static readonly VCT = new Country(
    CountryId.VCT,
    CountryISO3.VCT,
    CountryISO2.VC,
    $t('Saint Vincent and the Grenadines'),
  )
  static readonly SWZ = new Country(CountryId.SWZ, CountryISO3.SWZ, CountryISO2.SZ, $t('Eswatini'))
  static readonly SYR = new Country(CountryId.SYR, CountryISO3.SYR, CountryISO2.SY, $t('Syria'))
  static readonly SLB = new Country(
    CountryId.SLB,
    CountryISO3.SLB,
    CountryISO2.SB,
    $t('Solomon Islands'),
  )
  static readonly ESP = new Country(CountryId.ESP, CountryISO3.ESP, CountryISO2.ES, $t('Spain'))
  static readonly SWE = new Country(CountryId.SWE, CountryISO3.SWE, CountryISO2.SE, $t('Sweden'))
  static readonly CHE = new Country(
    CountryId.CHE,
    CountryISO3.CHE,
    CountryISO2.CH,
    $t('Switzerland'),
  )
  static readonly TJK = new Country(
    CountryId.TJK,
    CountryISO3.TJK,
    CountryISO2.TJ,
    $t('Tajikistan'),
  )
  static readonly TZA = new Country(CountryId.TZA, CountryISO3.TZA, CountryISO2.TZ, $t('Tanzania'))
  static readonly THA = new Country(CountryId.THA, CountryISO3.THA, CountryISO2.TH, $t('Thailand'))
  static readonly TWN = new Country(CountryId.TWN, CountryISO3.TWN, CountryISO2.TW, $t('Taiwan'))
  static readonly TGO = new Country(CountryId.TGO, CountryISO3.TGO, CountryISO2.TG, $t('Togo'))
  static readonly TKL = new Country(CountryId.TKL, CountryISO3.TKL, CountryISO2.TK, $t('Tokelau'))
  static readonly TON = new Country(CountryId.TON, CountryISO3.TON, CountryISO2.TO, $t('Tonga'))
  static readonly TTO = new Country(
    CountryId.TTO,
    CountryISO3.TTO,
    CountryISO2.TT,
    $t('Trinidad and Tobago'),
  )
  static readonly TUN = new Country(CountryId.TUN, CountryISO3.TUN, CountryISO2.TN, $t('Tunisia'))
  static readonly TUR = new Country(CountryId.TUR, CountryISO3.TUR, CountryISO2.TR, $t('Turkey'))
  static readonly TKM = new Country(
    CountryId.TKM,
    CountryISO3.TKM,
    CountryISO2.TM,
    $t('Turkmenistan'),
  )
  static readonly TCA = new Country(
    CountryId.TCA,
    CountryISO3.TCA,
    CountryISO2.TC,
    $t('Turks and Caicos Islands'),
  )
  static readonly TUV = new Country(CountryId.TUV, CountryISO3.TUV, CountryISO2.TV, $t('Tuvalu'))
  static readonly UGA = new Country(CountryId.UGA, CountryISO3.UGA, CountryISO2.UG, $t('Uganda'))
  static readonly UKR = new Country(CountryId.UKR, CountryISO3.UKR, CountryISO2.UA, $t('Ukraine'))
  static readonly URY = new Country(CountryId.URY, CountryISO3.URY, CountryISO2.UY, $t('Uruguay'))
  static readonly UZB = new Country(
    CountryId.UZB,
    CountryISO3.UZB,
    CountryISO2.UZ,
    $t('Uzbekistan'),
  )
  static readonly CXR = new Country(
    CountryId.CXR,
    CountryISO3.CXR,
    CountryISO2.CX,
    $t('Christmas Island'),
  )
  static readonly VUT = new Country(CountryId.VUT, CountryISO3.VUT, CountryISO2.VU, $t('Vanuatu'))
  static readonly VAT = new Country(CountryId.VAT, CountryISO3.VAT, CountryISO2.VA, $t('Vatican'))
  static readonly GBR = new Country(
    CountryId.GBR,
    CountryISO3.GBR,
    CountryISO2.GB,
    $t('United Kingdom'),
  )
  static readonly VEN = new Country(CountryId.VEN, CountryISO3.VEN, CountryISO2.VE, $t('Venezuela'))
  static readonly VNM = new Country(CountryId.VNM, CountryISO3.VNM, CountryISO2.VN, $t('Vietnam'))
  static readonly TLS = new Country(
    CountryId.TLS,
    CountryISO3.TLS,
    CountryISO2.TL,
    $t('East Timor'),
  )
  static readonly ZMB = new Country(CountryId.ZMB, CountryISO3.ZMB, CountryISO2.ZM, $t('Zambia'))
  static readonly ESH = new Country(
    CountryId.ESH,
    CountryISO3.ESH,
    CountryISO2.EH,
    $t('Western Sahara'),
  )
  static readonly ZWE = new Country(CountryId.ZWE, CountryISO3.ZWE, CountryISO2.ZW, $t('Zimbabwe'))
  static readonly MNE = new Country(
    CountryId.MNE,
    CountryISO3.MNE,
    CountryISO2.ME,
    $t('Montenegro'),
  )
  static readonly XKX = new Country(CountryId.XKX, CountryISO3.XKX, CountryISO2.XK, $t('Kosovo'))
  static readonly SRB = new Country(CountryId.SRB, CountryISO3.SRB, CountryISO2.RS, $t('Serbia'))
  static readonly AZE = new Country(
    CountryId.AZE,
    CountryISO3.AZE,
    CountryISO2.AZ,
    $t('Azerbaijan'),
  )
  static readonly ALA = new Country(
    CountryId.ALA,
    CountryISO3.ALA,
    CountryISO2.AX,
    $t('Aland Islands'),
  )
  static readonly BES = new Country(
    CountryId.BES,
    CountryISO3.BES,
    CountryISO2.BQ,
    $t('Bonaire, Sint Eustatius and Saba'),
  )
  static readonly CUW = new Country(CountryId.CUW, CountryISO3.CUW, CountryISO2.CW, $t('Curacao'))
  static readonly GUF = new Country(
    CountryId.GUF,
    CountryISO3.GUF,
    CountryISO2.GF,
    $t('French Guiana'),
  )
  static readonly PYF = new Country(
    CountryId.PYF,
    CountryISO3.PYF,
    CountryISO2.PF,
    $t('French Polynesia'),
  )
  static readonly ATF = new Country(
    CountryId.ATF,
    CountryISO3.ATF,
    CountryISO2.TF,
    $t('French Southern Territories'),
  )
  static readonly GLP = new Country(
    CountryId.GLP,
    CountryISO3.GLP,
    CountryISO2.GP,
    $t('Guadeloupe'),
  )
  static readonly GGY = new Country(CountryId.GGY, CountryISO3.GGY, CountryISO2.GG, $t('Guernsey'))
  static readonly IMN = new Country(
    CountryId.IMN,
    CountryISO3.IMN,
    CountryISO2.IM,
    $t('Isle of Man'),
  )
  static readonly JEY = new Country(CountryId.JEY, CountryISO3.JEY, CountryISO2.JE, $t('Jersey'))
  static readonly MTQ = new Country(
    CountryId.MTQ,
    CountryISO3.MTQ,
    CountryISO2.MQ,
    $t('Martinique'),
  )
  static readonly MYT = new Country(CountryId.MYT, CountryISO3.MYT, CountryISO2.YT, $t('Mayotte'))
  static readonly NCL = new Country(
    CountryId.NCL,
    CountryISO3.NCL,
    CountryISO2.NC,
    $t('New Caledonia'),
  )
  static readonly PSE = new Country(
    CountryId.PSE,
    CountryISO3.PSE,
    CountryISO2.PS,
    $t('Occupied Palestinian Territory'),
  )
  static readonly REU = new Country(CountryId.REU, CountryISO3.REU, CountryISO2.RE, $t('Réunion'))
  static readonly BLM = new Country(
    CountryId.BLM,
    CountryISO3.BLM,
    CountryISO2.BL,
    $t('Saint Barthélemy'),
  )
  static readonly MAF = new Country(
    CountryId.MAF,
    CountryISO3.MAF,
    CountryISO2.MF,
    $t('Saint Martin'),
  )
  static readonly SPM = new Country(
    CountryId.SPM,
    CountryISO3.SPM,
    CountryISO2.PM,
    $t('Saint Pierre and Miquelon'),
  )
  static readonly SXM = new Country(
    CountryId.SXM,
    CountryISO3.SXM,
    CountryISO2.SX,
    $t('Sint Maarten'),
  )
  static readonly SSD = new Country(
    CountryId.SSD,
    CountryISO3.SSD,
    CountryISO2.SS,
    $t('South Sudan'),
  )
  static readonly WLF = new Country(
    CountryId.WLF,
    CountryISO3.WLF,
    CountryISO2.WF,
    $t('Wallis and Futuna'),
  )
  static readonly PSX = new Country(CountryId.PSX, CountryISO3.PSX, CountryISO2.PS, $t('Palestine'))

  /**
   * @deprecated Yugoslavia no longer exists, kept only for legacy data still referencing it.
   * Left out of {@link Country.all} on purpose, so it cannot be picked for new data.
   */
  static readonly YUG = new Country(
    CountryId.YUG,
    CountryISO3.YUG,
    CountryISO2.YU,
    $t('Yugoslavia'),
  )

  static getById = (id: CountryId): Country => {
    const value = Country.active().find((item) => item.id === id)

    if (value === undefined) {
      throw new CodebookValueNotFoundError(Country.name, id)
    }

    return value
  }

  static getByIso3 = (iso3: CountryISO3): Country => {
    const value = Country.active().find((item) => item.iso3 === iso3)

    if (value === undefined) {
      throw new CodebookValueNotFoundError(Country.name, iso3)
    }

    return value
  }

  static getByIso2 = (iso2: CountryISO2): Country => {
    const value = Country.tryGetByIso2(iso2)

    if (value === null) {
      throw new CodebookValueNotFoundError(Country.name, iso2)
    }

    return value
  }

  static tryGetByIso2 = (iso2: string): Country | null => {
    return Country.active().find((item) => item.iso2 === iso2) ?? null
  }

  /**
   * Exclude non-existent countries
   */
  private static active = (): Country[] => {
    return [...Country.all(), Country.YUG]
  }

  /**
   * Mirrors BE Country::getPrevioCountries() including order
   */
  static previoCountries = (): Country[] => {
    return [Country.CZE, Country.HUN, Country.POL, Country.ROU, Country.SVK]
  }

  static topCountries = (): Country[] => {
    return [
      Country.AUS,
      Country.BEL,
      Country.CZE,
      Country.DNK,
      Country.FIN,
      Country.FRA,
      Country.IRL,
      Country.ITA,
      Country.CAN,
      Country.HUN,
      Country.DEU,
      Country.NLD,
      Country.POL,
      Country.AUT,
      Country.RUS,
      Country.SVK,
      Country.USA,
      Country.ESP,
      Country.SWE,
      Country.GBR,
    ]
  }

  /**
   * Mirrors BE Country::isTerritory() - both lists have to stay in sync
   * (getSovereignCountry() + TERRITORIES_WITHOUT_SOVEREIGN, pinned by CountryTest::territorySetMatchesTheP1CodeBook)
   */
  static territories = (): Country[] => {
    return [
      Country.ASM,
      Country.VIR,
      Country.AIA,
      Country.ATA,
      Country.ABW,
      Country.BMU,
      Country.BVT,
      Country.IOT,
      Country.VGB,
      Country.COK,
      Country.FRO,
      Country.FLK,
      Country.GIB,
      Country.GRL,
      Country.GUM,
      Country.HMD,
      Country.SGS,
      Country.YUG,
      Country.CYM,
      Country.CCK,
      Country.UMI,
      Country.MSR,
      Country.NIU,
      Country.NFK,
      Country.PCN,
      Country.PRI,
      Country.MNP,
      Country.SJM,
      Country.SHN,
      Country.TKL,
      Country.TCA,
      Country.CXR,
      Country.ESH,
      Country.ALA,
      Country.BES,
      Country.CUW,
      Country.GUF,
      Country.PYF,
      Country.ATF,
      Country.GLP,
      Country.GGY,
      Country.IMN,
      Country.JEY,
      Country.MTQ,
      Country.MYT,
      Country.NCL,
      Country.PSE,
      Country.REU,
      Country.BLM,
      Country.MAF,
      Country.SPM,
      Country.SXM,
      Country.WLF,
    ]
  }

  static nationalities = (): Country[] => {
    const territories = Country.territories()

    return Country.all().filter((country) => !territories.includes(country))
  }

  static all = (): Country[] => {
    return [
      ...this.topCountries(),
      Country.AFG,
      Country.ALB,
      Country.DZA,
      Country.ASM,
      Country.VIR,
      Country.AND,
      Country.AGO,
      Country.AIA,
      Country.ATA,
      Country.ATG,
      Country.ARG,
      Country.ARM,
      Country.ABW,
      Country.AZE,
      Country.BHS,
      Country.BHR,
      Country.BGD,
      Country.BRB,
      Country.BLZ,
      Country.BLR,
      Country.BEN,
      Country.BMU,
      Country.BTN,
      Country.BOL,
      Country.BIH,
      Country.BWA,
      Country.BVT,
      Country.BRA,
      Country.IOT,
      Country.VGB,
      Country.BRN,
      Country.BGR,
      Country.BFA,
      Country.BDI,
      Country.COK,
      Country.TCD,
      Country.MNE,
      Country.CHN,
      Country.DMA,
      Country.DOM,
      Country.DJI,
      Country.EGY,
      Country.ECU,
      Country.ERI,
      Country.EST,
      Country.ETH,
      Country.FRO,
      Country.FLK,
      Country.FJI,
      Country.PHL,
      Country.GAB,
      Country.GMB,
      Country.GHA,
      Country.GIB,
      Country.GRD,
      Country.GRL,
      Country.GEO,
      Country.GUM,
      Country.GTM,
      Country.GIN,
      Country.GNB,
      Country.GUY,
      Country.HTI,
      Country.HMD,
      Country.HND,
      Country.HKG,
      Country.CHL,
      Country.HRV,
      Country.IND,
      Country.IDN,
      Country.IRQ,
      Country.IRN,
      Country.ISL,
      Country.ISR,
      Country.JAM,
      Country.JPN,
      Country.YEM,
      Country.ZAF,
      Country.SGS,
      Country.JOR,
      Country.CYM,
      Country.KHM,
      Country.CMR,
      Country.CPV,
      Country.QAT,
      Country.KAZ,
      Country.KEN,
      Country.KIR,
      Country.CCK,
      Country.COL,
      Country.COM,
      Country.COG,
      Country.COD,
      Country.PRK,
      Country.KOR,
      Country.XKX,
      Country.CRI,
      Country.CUB,
      Country.KWT,
      Country.CYP,
      Country.KGZ,
      Country.LAO,
      Country.LSO,
      Country.LBN,
      Country.LBR,
      Country.LBY,
      Country.LIE,
      Country.LTU,
      Country.LVA,
      Country.LUX,
      Country.MAC,
      Country.MDG,
      Country.MKD,
      Country.MYS,
      Country.MWI,
      Country.MDV,
      Country.MLI,
      Country.MLT,
      Country.MAR,
      Country.MHL,
      Country.MUS,
      Country.MRT,
      Country.UMI,
      Country.MEX,
      Country.FSM,
      Country.MDA,
      Country.MCO,
      Country.MNG,
      Country.MSR,
      Country.MOZ,
      Country.MMR,
      Country.NAM,
      Country.NRU,
      Country.NPL,
      Country.NER,
      Country.NGA,
      Country.NIC,
      Country.NIU,
      Country.NFK,
      Country.NOR,
      Country.NZL,
      Country.OMN,
      Country.PAK,
      Country.PLW,
      Country.PSE,
      Country.PAN,
      Country.PNG,
      Country.PRY,
      Country.PER,
      Country.PCN,
      Country.CIV,
      Country.PRI,
      Country.PRT,
      Country.GNQ,
      Country.ROU,
      Country.RWA,
      Country.GRC,
      Country.SLV,
      Country.WSM,
      Country.SMR,
      Country.SAU,
      Country.SEN,
      Country.MNP,
      Country.SYC,
      Country.SLE,
      Country.SGP,
      Country.SVN,
      Country.SOM,
      Country.ARE,
      Country.SRB,
      Country.LKA,
      Country.CAF,
      Country.SDN,
      Country.SUR,
      Country.SJM,
      Country.SHN,
      Country.LCA,
      Country.KNA,
      Country.STP,
      Country.VCT,
      Country.SWZ,
      Country.SYR,
      Country.SLB,
      Country.CHE,
      Country.TJK,
      Country.TZA,
      Country.THA,
      Country.TWN,
      Country.TGO,
      Country.TKL,
      Country.TON,
      Country.TTO,
      Country.TUN,
      Country.TUR,
      Country.TKM,
      Country.TCA,
      Country.TUV,
      Country.UGA,
      Country.UKR,
      Country.URY,
      Country.UZB,
      Country.CXR,
      Country.VUT,
      Country.VAT,
      Country.VEN,
      Country.VNM,
      Country.TLS,
      Country.ZMB,
      Country.ESH,
      Country.ZWE,
      Country.ALA,
      Country.BES,
      Country.CUW,
      Country.GUF,
      Country.PYF,
      Country.ATF,
      Country.GLP,
      Country.GGY,
      Country.IMN,
      Country.JEY,
      Country.MTQ,
      Country.MYT,
      Country.NCL,
      Country.REU,
      Country.BLM,
      Country.MAF,
      Country.SPM,
      Country.SXM,
      Country.SSD,
      Country.WLF,
      Country.PSX,
    ]
  }
}
